import React from "react";

function MenuIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 56 56"
      version="1.1"
      viewBox="0 0 56 56"
      xmlSpace="preserve"
    >
      <path d="M28 0C12.561 0 0 12.561 0 28s12.561 28 28 28 28-12.561 28-28S43.439 0 28 0zm0 54C13.663 54 2 42.336 2 28S13.663 2 28 2s26 11.664 26 26-11.663 26-26 26z"></path>
      <path d="M40 16H16a1 1 0 100 2h24a1 1 0 100-2zM40 27H16a1 1 0 100 2h24a1 1 0 100-2zM40 38H16a1 1 0 100 2h24a1 1 0 100-2z"></path>
    </svg>
  );
}

export default MenuIcon;
